<template>
  <div class="relative overflow-hidden bg-gradient-to-br from-accent/5 via-gradient-start/5 to-gradient-end/5 pt-36 dark:from-accent/10 dark:via-gradient-start/10 dark:to-gradient-end/10">
    <!-- Background Elements -->
    <div class="absolute inset-0 opacity-30">
      <div class="absolute inset-0 bg-gradient-to-r from-transparent via-accent/5 to-transparent" />
    </div>

    <!-- Accent glow -->
    <div class="absolute -top-24 left-1/2 size-96 -translate-x-1/2 rounded-full bg-gradient-to-r from-accent/20 to-gradient-end/20 blur-3xl" />

    <div class="container relative mx-auto px-6 py-16">
      <div class="mx-auto max-w-7xl">
        <div class="mb-8 text-center">
          <!-- Icon (optional) -->
          <div v-if="icon" class="mb-6 flex justify-center">
            <div class="flex size-20 items-center justify-center rounded-3xl bg-gradient-to-r from-accent to-gradient-end shadow-lg">
              <component :is="icon" class="size-10 text-white" />
            </div>
          </div>

          <!-- Title -->
          <h1 class="mb-6 text-4xl font-bold text-ternary-dark dark:text-primary-light sm:text-5xl lg:text-6xl">
            <template v-if="highlightedTitle">
              {{ title }} <span class="bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-transparent">{{ highlightedTitle }}</span>
            </template>
            <template v-else>
              {{ title }}
            </template>
          </h1>

          <!-- Description -->
          <p v-if="description" class="mx-auto mb-8 max-w-3xl text-xl text-gray-600 dark:text-gray-400">
            {{ description }}
          </p>

          <!-- Meta Information (optional) -->
          <div v-if="metaInfo && metaInfo.length > 0" class="flex flex-wrap justify-center gap-6">
            <div v-for="(meta, index) in metaInfo" :key="index" class="flex items-center">
              <component :is="meta.icon" class="size-5 text-ternary-dark dark:text-ternary-light" />
              <span v-if="meta.url" class="ml-2">
                <a
                  :href="meta.url"
                  target="_blank"
                  rel="nofollow noopener"
                  class="font-medium text-primary-dark transition-colors duration-300 hover:text-accent dark:text-primary-light"
                >{{ meta.text }}</a>
              </span>
              <span v-else class="ml-2 font-medium text-primary-dark dark:text-primary-light">
                {{ meta.text }}
              </span>
            </div>
          </div>

          <!-- Custom Content Slot -->
          <div v-if="$slots.default" class="mt-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface MetaInfo {
  icon: any
  text: string
  url?: string
}

interface Props {
  icon?: any
  title: string
  highlightedTitle?: string
  description?: string
  metaInfo?: MetaInfo[]
}

defineProps<Props>()
</script>
